<template>
<el-card class="h-full" :body-style="{ height: '100%' }">
    <el-row class="mb-10px" type="flex" align="middle">
        <span class="text-14px leading-36px mr-10px">数据标准库</span><selectStandardId @updateStandardId="updateStandardId" />
        <span class="text-14px leading-36px mr-10px ml-10px">文档目录名</span>
        <el-input
            class="w-200px mr-10px"
            size="small"
            v-model="searchData.FolderName"
            placeholder="请输入文档目录名"
            clearable
        ></el-input>
        <el-button size="small" type="primary" :disabled="!$hasAccess('read')" @click="searchList">搜索</el-button>
        <el-button size="small" type="primary" :disabled="!$hasAccess('export')" @click="exportData">导出</el-button>
    </el-row>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      class="mt-20px"
      height="calc(100% - 104px)"
      border
      stripe
    >
        <el-table-column label="文件夹路径" prop="path"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="创建人" prop="createUser"></el-table-column>
        <el-table-column label="失败原因详述" prop="description"></el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px text-right"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :page-sizes="$pageSizeAll"
      @current-change="getTableData"
      @size-change="searchList"
    >
    </el-pagination>
</el-card>

</template>
<script>
import dataValidationReportService from '@/services/dataValidationReportService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'
export default {
    name: 'emptyFileCategory',
    components: {
        selectStandardId,
    },
    mixins: [fnMixin],
    data() {
        return {
            tableLoading: false,
            tableData: [],
            standardId: localStorage.getItem('standardId'),
            searchData: {
                FolderName: ''
            },
            page: {
                pageNo: 1,
                pageSize: 15,
                total: 0,
            },
        }
    },
    methods: {
        // 导出
        async exportData() {
            const params = {
                StandardId: this.standardId,
                skipCount: (this.page.pageNo - 1) * this.page.pageSize,
                maxResultCount: this.page.pageSize,
                ...this.searchData,
            }
            this.exportLoading = true
            const res = await dataValidationReportService.getEmptyDocumentCategoryExport(params)
            this.exportLoading = false
            if (res) {
                this.downLoadBlob({
                    name: '空文档目录校验报表导出结果.xlsx',
                    data: res
                })
            }
        },
        updateStandardId(val) {
            this.standardId = val
            this.searchList()
        },
        // 搜索列表
        searchList() {
            this.page.pageNo = 1
            this.getTableData()
        },
        async getTableData() {
            const params = {
                StandardId: this.standardId,
                skipCount: (this.page.pageNo - 1) * this.page.pageSize,
                maxResultCount: this.page.pageSize,
                ...this.searchData,
            }
            this.tableLoading = true
            const res = await dataValidationReportService.getEmptyCategoryReport(params)
            this.tableLoading = false
            if (res && res.code === 0) {
                this.tableData = res.data
                this.page.total = res.totalCount
                setTimeout(() => {
                    $('.el-table__header').width($('.el-table__body').width())
                }, 500)
            }
        },
    },
    created() {
        this.searchList()
    }
}
</script>